import type {
  MovieOfTheNightStreamingOption,
  ServiceImageSet,
} from '@bldsoft/cappie/api/wbs'
import type { MotnServiceLogo, MotnStreamingOption } from '@setplex/tria-api'
import type { ApiType } from '../../shared/schemas'

import * as v from 'valibot'
import { formatResolution } from '../../utils/media'

export const MotnServiceLogoSchema = v.pipe(
  v.object({
    lightThemeImage: v.nullish(v.string()),
    darkThemeImage: v.nullish(v.string()),
  }),
  v.transform(
    (o): MotnServiceLogo => ({
      lightThemeImage: o.lightThemeImage ?? undefined,
      darkThemeImage: o.darkThemeImage ?? undefined,
    })
  )
) satisfies ApiType<ServiceImageSet, MotnServiceLogo>

export const MotnStreamingOptionSchema = v.pipe(
  v.object({
    serviceName: v.nullish(v.string()),
    serviceLogo: v.nullish(MotnServiceLogoSchema),
    accessInfo: v.nullish(
      v.picklist(['subscription', 'buy', 'rent', 'addon', 'free'])
    ),
    addon: v.nullish(v.string()),
    link: v.nullish(v.string()),
    quality: v.nullish(v.picklist(['HD', 'SD', 'FHD', '_2K', '_4K'])),
    price: v.nullish(v.string()),
  }),
  v.transform((data): MotnStreamingOption => {
    const { quality, accessInfo, serviceName, link, serviceLogo, ...rest } =
      data
    return {
      ...rest,
      serviceName: serviceName ?? undefined,
      link: link ?? undefined,
      serviceLogo: serviceLogo ?? undefined,
      accessInfo: accessInfo ?? undefined,
      quality:
        quality == null
          ? null
          : (formatResolution({ resolution: quality }) ?? null),
    }
  })
) satisfies ApiType<MovieOfTheNightStreamingOption, MotnStreamingOption>
